import { render, staticRenderFns } from "./PanelMobileSection.vue?vue&type=template&id=0bb4b6e5&scoped=true&"
import script from "./PanelMobileSection.vue?vue&type=script&lang=js&"
export * from "./PanelMobileSection.vue?vue&type=script&lang=js&"
import style0 from "./PanelMobileSection.vue?vue&type=style&index=0&id=0bb4b6e5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb4b6e5",
  null
  
)

component.options.__file = "PanelMobileSection.vue"
export default component.exports